

import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { BookOpen, MapPin, Camera } from 'lucide-react';
import { getStoredLanguage, normalizeLanguage } from '../utils/language';

const Footer = () => {
  const navigate = useNavigate();
  const [lang, setLang] = useState(getStoredLanguage());
  const t = (tr, en, ru) => {
    if (lang === 'EN') return en;
    if (lang === 'RU') return ru || en || tr;
    return tr;
  };
  useEffect(() => {
    try {
      setLang(getStoredLanguage());
    } catch (_) {}
    const handler = (e) => {
      const next = normalizeLanguage(e?.detail?.language);
      setLang(next);
    };
    if (typeof window !== 'undefined') window.addEventListener('app-language-change', handler);
    return () => { if (typeof window !== 'undefined') window.removeEventListener('app-language-change', handler); };
  }, []);
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4">Samsun Keşfet</h3>
            <p className="text-gray-300 mb-4">
              {t(
                "Samsun'un kültürel ve tarihi zenginliklerini keşfedin. Müzeler, anıtlar ve tarihi mekanları dijital rehberimizle deneyimleyin.",
                "Discover Samsun's cultural and historical richness. Explore museums, monuments and historic sites with our digital guide.",
                'Откройте культурное и историческое богатство Самсуна. Посетите музеи, памятники и исторические места с нашим цифровым гидом.'
              )}
            </p>
            <div className="text-sm text-gray-400">
              {t('Sosyal medya hesaplarımızı takip edin', 'Follow our social media accounts', 'Следите за нашими соцсетями')}
            </div>
          </div>

          {/* Kategoriler */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">{t('Kategoriler', 'Categories', 'Категории')}</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => navigate('/?category=Müzeler')}
                  className="text-gray-300 hover:text-white transition-colors duration-200 flex items-center gap-2"
                >
                  <BookOpen className="w-4 h-4" />
                  {t('Müzeler', 'Museums', 'Музеи')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/?category=Anıtlar')}
                  className="text-gray-300 hover:text-white transition-colors duration-200 flex items-center gap-2"
                >
                  <MapPin className="w-4 h-4" />
                  {t('Anıtlar', 'Monuments', 'Памятники')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/?category=Tarihi Mekanlar')}
                  className="text-gray-300 hover:text-white transition-colors duration-200 flex items-center gap-2"
                >
                  <Camera className="w-4 h-4" />
                  {t('Tarihi Mekanlar', 'Historic Sites', 'Исторические места')}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">{t('İletişim', 'Contact', 'Контакты')}</h4>

            {/* Ulaşım ve İletişim Linki */}
            <div>
              <button
                onClick={() => navigate('/contact-info')}
                className="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white text-sm font-medium rounded-lg hover:bg-primary-700 transition-colors duration-200"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                {t('Ulaşım ve İletişim', 'Transport & Contact', 'Транспорт и связь')}
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            {t('© 2025 Samsun Keşfet. Tüm hakları saklıdır.', '© 2025 Discover Samsun. All rights reserved.', '© 2025 Discover Samsun. Все права защищены.')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
